<script context="module">
  import { DIRECTIONS, SIZES } from '../utils'

  export { DIRECTIONS, SIZES }
</script>

<script>
  import { getClass } from '../utils'

  export let key
  export let size = SIZES.SMALL
  export let direction = DIRECTIONS.TOP_BOTTOM

  $: className = getClass({ key, direction, size, className: $$props.class || '' })
</script>

<span {...$$restProps} class={className} />
